export default __webpack_public_path__ + "static/media/TableEdit.2cc7f9e3.svg";